import axios from "axios";
import { useState } from "react";
import { LOG } from "../utils/logUtil";
import { useAppLoading } from "./useAppLoading";
export function useDirectUploadImage() {
  /** State */
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [thumbnailImage, setThumbnailImage] = useState<string | null>(null);

  /** Callbacks */
  const clearUploadedImage = () => setUploadedImage(null);

  const uploadImage = async (
    image: File,
    includeThumbnail: boolean = false
  ) => {
    useAppLoading.getState().setIsLoading(true);
    try {
      const body = new FormData();
      body.append("file", image);
      body.append("type", "dashboard");
      body.append("includeThumbnail", includeThumbnail ? "true" : "false");
      const response = await axios.post(
        "https://clean-cycle-dev.ew.r.appspot.com/storage/upload?=",
        body,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response?.data?.filePath) {
        setUploadedImage(response?.data?.filePath);
        setThumbnailImage(response?.data?.thumbnailPath ?? null);
      }
    } catch (error) {
      LOG.error("Error on uploading image", { error });
    } finally {
      useAppLoading.getState().setIsLoading(false);
    }
  };

  return {
    uploadedImage,
    setUploadedImage,
    clearUploadedImage,
    uploadImage,
    thumbnailImage,
    setThumbnailImage,
  };
}
